import { useQuery, useMutation } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { serviceUnits } from '../ServiceUnits';

type OptionsType = {
  enabled: boolean;
};

export const useServiceUnits = (options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.serviceUnits],
    queryFn: async () => (await serviceUnits.getServiceUnits()).data,
    enabled: options?.enabled,
  });

export const useCreateServiceUnit = () =>
  useMutation({ mutationFn: serviceUnits.createServiceUnits });
export const useUpdateServiceUnit = () =>
  useMutation({ mutationFn: serviceUnits.updateServiceUnits });
